const data: any = {
  rt: {
    "b": {
      "thisOpponent": "cet adversaire",
      "firstMatch": "Premier match",
      "lastMatch": "Dernier match · {{value}}",
      "oneRated": "vs {{name}} {{value}} · 1 match noté",
      "average": "vs {{name}} {{value}} · {{count}} matchs",
      "oneRatedMe": "contre moi {{value}} · 1 match noté",
      "averageMe": "contre moi {{value}} · {{count}} matchs",
      "comparisonControls": "Comparaisons historiques",
      "showH2H": "Moyennes des confrontations directes",
      "showOverall": "Moyennes générales de tous les matchs"
    },
    "f": {
      "shot_accuracy": "Précision des frappes",
      "call_accuracy": "Précision des annonces (dedans/dehors)",
      "confrontational_tendency": "Tendance à la confrontation",
      "forehand": "Coup droit",
      "backhand": "Revers",
      "service": "Service",
      "return": "Retour",
      "volley": "Volée",
      "smash": "Smash",
      "drop_shot": "Amortie",
      "lob": "Lob",
      "stamina": "Endurance",
      "speed": "Vitesse",
      "court_coverage": "Couverture du court",
      "tactics": "Tactique",
      "awareness": "Lecture du jeu",
      "shot_variety": "Variété de coups",
      "winners": "Coups gagnants",
      "unforced_errors": "Fautes directes",
      "fh_topspin": "Coup droit lifté",
      "fh_slice": "Coup droit slicé",
      "bh_topspin": "Revers lifté",
      "bh_slice": "Revers slicé",
      "first_serve": "1re balle",
      "first_serve_speed": "Vitesse 1re balle",
      "second_serve": "2e balle",
      "second_serve_speed": "Vitesse 2e balle",
      "serve_flat": "Service à plat",
      "serve_kick": "Service kické",
      "serve_slice": "Service slicé",
      "first_serve_pct_est": "1res balles passées (est.)",
      "second_serve_pct_est": "2es balles passées (est.)",
      "passing_shots": "Passing shot",
      "volley_d": "Volée",
      "tactics_d": "Tactique",
      "speed_d": "Vitesse",
      "stamina_d": "Endurance",
      "composure": "Sang-froid",
      "concentration": "Concentration",
      "calmness": "Calme",
      "anxiety": "Anxiété",
      "confidence": "Confiance",
      "fighting_spirit": "Combativité",
      "mental_resilience": "Résilience mentale",
      "belief_pre": "Croire en la victoire avant le match",
      "belief_in": "Croire en la victoire pendant le match"
    },
    "g": {
      "movement": "Déplacement et placement",
      "behaviour": "Comportement",
      "forehand": "Coup droit",
      "backhand": "Revers",
      "serve": "Service",
      "rally": "Échange et retour",
      "net": "Jeu au filet",
      "physical": "Physique et tactique"
    },
    "h": {
      "shot_accuracy": "Tes frappes sont-elles allées là où tu le voulais ?",
      "call_accuracy": "Tes annonces dedans/dehors étaient-elles justes selon toi ?",
      "confrontational_tendency": "Tendance aux désaccords, tensions ou confrontations avec l'adversaire."
    },
    "dist": {
      "winnersIncl": "Coups gagnants (aces inclus)",
      "unforcedIncl": "Fautes directes (doubles fautes incluses)",
      "assignTo": "Attribuer les {{n}} % restants à…",
      "countHint": "Vous avez noté {{a}} aces et {{d}} doubles fautes.",
      "remainingInline": "Reste {{n}} %",
      "complete": "Terminé — 100 % attribué",
      "assignRemainder": "Attribuer ici les {{n}} % restants",
      "tab": "Points",
      "title": "Comment les points se terminaient-ils ?",
      "helper": "C'est votre estimation : aucun comptage point par point n'est nécessaire. Des ordres de grandeur suffisent, et vous pouvez laisser vide.",
      "winners": "Coups gagnants",
      "forced": "Fautes provoquées",
      "unforced": "Fautes directes",
      "df": "Doubles fautes",
      "total": "Total",
      "remaining": "{{n}} % non attribués",
      "over": "{{n}} % au-dessus de 100",
      "myTeam": "Mon équipe",
      "oppTeam": "Équipe adverse"
    }
  },
  onboarding: {
    eyebrow: "Démarrer",
    valueHistory: "Construisez votre historique de matchs",
    valueStats: "Comprenez vos statistiques",
    valueImprove: "Suivez vos progrès dans le temps",
    showMore: "Fonctionnement et fonctionnalités",
    showLess: "Afficher moins",
    headlineDashboard: "Votre tableau de bord attend son premier match",
    headlineMatches: "Enregistrez un match pour démarrer votre historique",
    headlineStats: "Les stats se débloquent après votre premier match",
    intro: "Tennis Log transforme chaque match en analyse. Enregistrez le premier en moins d'une minute et voyez votre tableau de bord, vos graphiques et votre coach IA prendre vie.",
    cta: "+ Enregistrer le premier match",
    howTitle: "Comment ça marche",
    s1Title: "Ajouter un match",
    s1Desc: "Touchez « Nouveau match », remplissez date, adversaire, court et scores. Les listes déroulantes accélèrent tout.",
    s2Title: "Ajouter du détail (optionnel)",
    s2Desc: "Jeu par jeu, conditions, doubles fautes, notations — aussi loin que vous voulez, ou juste le score.",
    s3Title: "Voir vos stats",
    s3Desc: "Taux de victoire, hold, break, sets, jeux, surface, court, adversaire — tout se met à jour instantanément.",
    s4Title: "Obtenir des insights IA",
    s4Desc: "L’analyse IA est disponible dès que vous avez enregistré des données de match et devient généralement plus informative à mesure que votre historique s’enrichit.",
    benefitsTitle: "Ce que vous verrez après vos matchs",
    b1Title: "Taux de victoire global",
    b1Desc: "Filtrez par année, format (simple/double/mixte) et type (amical/officiel). Repérez les tendances.",
    b2Title: "Sets, jeux, hold & break",
    b2Desc: "Au-delà du V/D : tenez-vous votre service, breakez-vous, différentiel de sets et de jeux.",
    b3Title: "Stats smartwatch",
    b3Desc: "Importez un screenshot Mi Fitness, Garmin, Apple Watch ou Zepp — l'IA remplit calories, BPM et zones FC.",
    b4Title: "Heatmap jeu par jeu",
    b4Desc: "Découvrez si vous craquez au jeu 3 ou concluez le 11 — par côté de service et par set.",
    b5Title: "Notes de performance",
    b5Desc: "Notez coup droit, revers, service, retour, volée, lecture, couverture du court. Visualisez en radar.",
    b6Title: "Coach IA",
    b6Desc: "Un récit personnel de vos forces, faiblesses et schémas — écrit comme un coach, à partir de vos données.",
    tipsTitle: "Conseils pour la première saisie",
    tip1: "Commencez simple : date, adversaire et scores suffisent.",
    tip2: "Ajoutez court et surface — vous verrez vite où vous jouez le mieux.",
    tip3: "Essayez un set jeu par jeu pour débloquer hold rate et heatmaps.",
    tip4: "Notez-vous honnêtement — quelques entrées suffisent à nourrir l'IA.",
    tip5: "Vous avez d'anciens matchs ? Saisissez-les aussi. L'historique fait les stats.",
  },
  nav: { dashboard: "Tableau de bord", matches: "Matchs", add: "Nouveau match", stats: "Stats", insights: "Insights IA", logout: "Déconnexion" , settings: "Paramètres", invite: "Inviter un ami" },
  brand: { name: "My Tennis Ledger", tagline: "Progressez en étudiant votre historique de tennis" },
  auth: { age16: "Je confirme avoir au moins 16 ans. Les comptes Tennis Log sont réservés aux personnes de 16 ans et plus.", age16Required: "Confirmez que vous avez au moins 16 ans.", signIn: "Se connecter", signUp: "S'inscrire", email: "E-mail", password: "Mot de passe", name: "Nom", createAccount: "Créer un compte", or: "ou", continueGoogle: "Continuer avec Google", welcomeBack: "Bon retour !", accountCreated: "Compte créé !", passwordInfoLabel: "Exigences du mot de passe", passwordHelp: "Utilisez au moins 8 caractères. Les majuscules, chiffres ou symboles ne sont pas obligatoires, mais évitez les mots de passe très courants ou faciles à deviner. Les mots de passe apparus dans des fuites connues ne sont pas acceptés.", passwordTooShort: "Le mot de passe doit contenir au moins 8 caractères.", passwordWeakLeaked: "Ce mot de passe est trop courant ou est apparu dans une fuite de données connue. Choisissez-en un plus unique.", passwordRejected: "Ce mot de passe n'a pas été accepté. Vérifiez les exigences à côté du champ et réessayez.", passwordMinLabel: "Au moins 8 caractères", requirementMet: "exigence remplie", requirementNotMet: "exigence pas encore remplie", sameMethodHint: "Utilisez la même méthode de connexion que celle utilisée lors de la création de votre compte.", signInFailed: "E-mail ou mot de passe incorrect. Si vous avez créé votre compte avec Google, connectez-vous avec Google." },
  authPage: {
    heroTitle: "Commence à écrire ton histoire au tennis",
    heroSubtitle: "Enregistre tes matchs en quelques minutes, repère tes tendances et laisse tes stats te montrer quoi améliorer ensuite.",
    trustFree: "Fonctionnalités de base gratuites",
    trustData: "Tes données restent les tiennes",
    trustDevice: "Fonctionne sur mobile et web",
    dashboardAlt: "Tableau de bord Tennis Log : taux de victoires, sets, jeux et pourcentage de hold",
    dashboardCaption: "Après quelques matchs, ton tableau de bord commence à afficher taux de victoires, hold, breaks, tendances et insights IA.",
    founderQuote: "J'ai créé Tennis Log parce que je voulais arrêter d'oublier mes propres matchs. Il suffit de jouer, de se souvenir de l'évolution du score et de l'enregistrer. Je suis convaincu que ce sera utile pour toi aussi. Profites-en !",
    founderTitle: "Fondateur de Tennis Log — My Tennis Ledger",
    founderLocation: "Joueur de club niveau avancé, Grèce",
    notReadyTitle: "Pas encore prêt à t'inscrire ?",
    notReadySub: "Explore d'abord le contenu public — tout est ouvert, aucun compte nécessaire.",
    viewDemoTitle: "Voir la démo publique",
    viewDemoDesc: "Découvre ce que Tennis Log révèle après ~25 matchs — avec de vrais graphiques.",
    readGuideTitle: "Lire le Guide des Statistiques de Tennis",
    readGuideDesc: "Quelles stats comptent vraiment et comment les lire.",
    browseBlogTitle: "Parcourir le Blog",
    browseBlogDesc: "Articles sur hold/break, tendance des victoires, smartwatch, insights IA et mental.",
    open: "Ouvrir",
  },
  common: {
    all: "Tous", singles: "Simple", doubles: "Double", mixed: "Mixte",
    friendly: "Amical", official: "Officiel",
    me: "Moi", opponent: "Adversaire", year: "Année", draw: "Égalité",
    cancel: "Annuler", save: "Enregistrer", saving: "Enregistrement...", loading: "Chargement...",
    delete: "Supprimer", edit: "Modifier", search: "Rechercher", close: "Fermer",
    matches: "matchs", other: "Autre (préciser)",
    loadFailed: "Impossible de charger vos données", loadFailedBody: "Un problème est survenu pendant le chargement. Vérifiez votre connexion et réessayez.", retry: "Réessayer",
  },
  conditions: { sun: "Soleil dans les yeux", wind: "Vent", noise: "Bruit / public", cold: "Froid", rain: "Pluie", slippery: "Terrain glissant", humidity: "Humidité", strong_wind: "Vent fort" },
  dashboard: {
    title: "Tableau de bord", subtitle: "Votre saison en un coup d'œil.",
    newMatch: "+ Nouveau match", statsFilter: "Filtre stats", trendFilter: "Filtre tendance",
    trendTitle: "Évolution du taux de victoire", recent: "Matchs récents", seeAll: "Tous →",
    noMatches: "Aucun match.", addFirst: "Ajouter le premier",
    noFilter: "Aucun match pour ce filtre.",
    overallWinRate: "Taux de victoire global", winRate: "Taux de victoire", clickDot: "Cliquez pour modifier le match", sets: "Sets", games: "Jeux", holdRate: "Taux de hold",
    breaksWon: "Breaks gagnés", breaksWonSub: "{{breaks}} sur {{total}} jeux de retour",
    serviceGames: "jeux de service", returnGames: "jeux de retour",
    winAfterFirstSet: "Victoire après gain du 1er set", winAfterFirstSetSub: "{{wins}} sur {{total}} matchs", surfaceFilter: "Surface",
    setsWon: "Sets gagnés", gamesWon: "Jeux gagnés", breakRate: "Taux de break",
    currentForm: "Forme actuelle", formEmpty: "Aucun match terminé pour l'instant",
    trendDelta: "Taux de victoire {{pp}} pts vs les 10 précédents",
    trendStable: "Taux de victoire stable vs les 10 précédents",
    trendUnavailable: "Tendance disponible après {{count}} matchs",
    discovery: {
      title: "Ce que votre tennis vous dit",
      family: { improving: "En progrès", edge: "Votre atout", watch: "À surveiller" },
    },
  },
  match: {
    opponentPrivacyHint: "Facultatif. Ces informations concernent une autre personne : notez seulement ce qui sert votre analyse et restez factuel.",
    basics: "Infos", players: "Joueurs", score: "Score par set",
    invalidSetScore: "Score impossible au set {{set}} — le vainqueur doit atteindre le total requis avec 2 d'écart.", notes: "Notes",
    watch: "Données smartwatch", rating: "Évaluation du match (1–10)",
    surface: "Surface", temperature: "Température ({{unit}})",
    setType: "Type de set", standardSet: "Standard", shortSet: "Short Set (à 4 jeux)", superTb: "Super TB (10p)", tb7: "Tie-break 7p", tb11: "Tie-break 11p",
    tbPointByPoint: "Point par point", tbUndo: "Annuler", tbClear: "Effacer", tbDecided: "Terminé",
    date: "Date", time: "Heure", day: "Jour", court: "Court", courtCustomPlaceholder: "ex. Club Court #1",
    format: "Format", kind: "Type",
    set: "Set", firstServer: "Premier service :",
    missingOpponent: "Indiquez le nom de l'adversaire pour enregistrer le match.", missingCourt: "Indiquez le nom du court pour enregistrer le match.",
    opponentRequired: "Adversaire *", myPartner: "Mon partenaire", oppPartner: "Partenaire adverse",
    teams: "Équipes", teamsHint: "Mon équipe (moi + partenaire) vs équipe adverse (adversaire 1 + adversaire 2).",
    myTeam: "Mon équipe",
    opponentTeam: "Équipe adverse",
    opponent1: "Adversaire 1",
    opponent2: "Adversaire 2",
    doublesPlayersRequired: "Ajoute ton partenaire et les deux adversaires pour enregistrer le double.",
    age: "Âge", experience: "Années d'expérience", backhand: "Revers", playstyle: "Style de jeu",

    notesPlaceholder: "Comment s'est passé le match ?",
    summaryTab: "Résumé", detailedTab: "Détaillé",
    watchHint: "Téléchargez une capture Mi Fitness/Garmin/Apple Watch — auto-rempli via IA.",
    ratingHint: "Laissez vide ce que vous ne voulez pas évaluer.",
    saveMatch: "Enregistrer", saveChanges: "Enregistrer",
    addTitle: "Nouveau match", addSubtitle: "Remplissez les détails.",
    editTitle: "Modifier le match", editSubtitle: "Mettez à jour et enregistrez.",
    saved: "Match enregistré !", changesSaved: "Modifications enregistrées !", notFound: "Match introuvable",
    retired: "Y a-t-il eu un abandon ?", retiredNone: "Non", retiredYes: "Oui", retiredMe: "J'ai abandonné", retiredOpp: "Adversaire a abandonné",
    specialEnding: "Fin de match particulière",
    scoreMismatchTitle: "Le score ne correspond pas",
    scoreMismatchBody: "La progression enregistrée donne {{derived}}, alors que le score final indique {{declared}}. Vérifie avant de continuer.",
    scoreMismatchFix: "Corriger le score final",
    declaredScore: "Score déclaré",
    declaredScoreHint: "C’est le score final indiqué à l’étape 1. Maintenant, indique comment le set s’est déroulé.",
    declaredScorePrompt: "Tu as indiqué que le <highlight>Set {{set}} s’est terminé {{score}}</highlight>. Maintenant, indique comment le score a évolué.",
    incompleteSetTimePrompt: "Tu as indiqué que le <highlight>Set {{set}} est arrivé à {{score}}</highlight> sans se terminer, probablement parce que le temps était écoulé. Saisis uniquement les games joués afin qu’ils soient pris en compte dans l’Elo.",
    timelineLiveScore: "Score jeu par jeu en cours",
    scoreMismatchBlock: "Le score jeu par jeu ne correspond pas au score final. Corrige l’écart avant de continuer.",
    gameSequenceNext: "Saisis les jeux dans l’ordre · Suivant : Jeu {{game}}",
    gameSequenceGap: "Le Jeu {{missing}} manque avant le Jeu {{later}}. Complète-le d’abord.",
    gameSequenceBlock: "Complète les jeux manquants dans l’ordre avant de continuer.",
    doubleFaults: "Doubles fautes",
    dfMe: "Mes doubles fautes",
    dfOpp: "Doubles fautes adverse",
    aces: "Aces",
    acesMe: "Mes aces",
    acesOpp: "Aces adverse",
    context: "Contexte & conditions",
    contextHint: "Facteurs externes et personnels qui ont pu affecter le jeu.",
    conditions: "Conditions physiques",
    personalIssues: "Difficultés personnelles",
    personalIssuesPlaceholder: "ex. mal de tête, douleur au genou, fatigue…",
    psychTab: "Psychologie",
    oppAge: "Âge de l'adversaire",
    oppBackhand: "Revers adverse",
    bhSingle: "À une main",
    bhDouble: "À deux mains",
    oppPlaystyle: "Style de jeu",
    styleOffensive: "Offensif",
    styleDefensive: "Défensif",
    styleAllCourt: "Polyvalent",
    floodlights: "Sous projecteurs",
    rainy: "Temps pluvieux",
    tiringDay: "Journée fatigante / dure au travail",
    napped: "Sieste à midi",
    heavyMeal: "Repas lourd",
    fasted: "À jeun",
    anxiousFlag: "Anxieux",
    tournamentRound: "Tour du tournoi",
    tournamentName: "Nom du tournoi",
    sleepHours: "Sommeil la nuit dernière (h)",
    ballsState: "État des balles",
    ballsNew: "Neuves", ballsUsed: "Usagées",
    ballsUseCount: "Nombre d'utilisations",
    ballsUseSuffix: "x",
    oppExperience: "Années d'expérience",
    racketStrungAt: "Cordage de la raquette",
    racketStrungAgo: "il y a {{n}} jours",
    racketStrungToday: "aujourd'hui",
    individualConditions: "Conditions personnelles",
    daysSinceLastMatch: "Jours depuis le dernier match",
    daysAgo: "il y a {{n}} jours",
    ballsUsed1: "1x utilisées", ballsUsed2: "2x utilisées", ballsUsed3: "3x utilisées",
    oppHandedness: "Main", righty: "Droitier", lefty: "Gaucher",
    weightKg: "Poids ({{unit}})", bmi: "IMC", bmiNoHeight: "Renseignez votre taille dans le profil pour calculer l'IMC",
    hLegend: "H = Hold", bLegend: "B = Break",
    cellHowTo: "Un clic sur la case du serveur pour Hold (H), double clic pour Break (B). Un clic de plus efface la case.",
    gameDetail: {
      toggle: "Ajouter le détail par jeu",
      toggleHint: "Facultatif : touchez un jeu terminé pour noter le score atteint par le joueur qui l’a perdu.",
      gameN: "Jeu {{n}}",
      openSheet: "Ajouter un détail",
      youServed: "vous serviez", oppServed: "l'adversaire servait",
      held: "hold", wasBroken: "vous avez été breaké", oppHeld: "hold de l'adversaire", youBroke: "vous avez breaké",
      question: "Jusqu'où est allé le perdant du jeu ?",
      deuce: "Égalité",
      gamePointQuestion: "Le perdant a-t-il eu une balle de jeu ?",
      yes: "Oui", no: "Non",
      clearDetail: "Effacer le détail", changeResult: "Changer le résultat",
      hold: "Hold", break: "Break", clearResult: "Effacer le résultat",
      token: { "0": "Arrivé à 0", "15": "Arrivé à 15", "30": "Arrivé à 30", D: "Égalité, sans balle de jeu", DG: "Égalité, avec balle de jeu" },
    },
  },
  matches: {
    title: "Matchs", subtitle: "Tout votre historique.",
    searchOpponent: "Chercher un adversaire", searchPlaceholder: "ex. Dupont",
    format: "Format", confrontation: "Type",
    matchesCount: "{{count}} matchs",
    none: "Aucun match", new: "+ Nouveau",
    setGameByGame: "Set {{n}} — jeu par jeu",
    confirmDelete: "Supprimer le match ? Action irréversible.",
    deleted: "Supprimé",
    singular: "Simple", duplet: "Double", official: "Officiel", friendly: "Amical",
  },
  stats: {
    perGameSelectionDetails: "{{wins}} réussis sur {{total}} jeux enregistrés",
    trendSelectedMatch: "Match sélectionné",
    trendOpenMatch: "Voir le match",
    tempStepLabel: "Intervalle de température (°C)",
    ageStepLabel: "Intervalle d’âge (années)",
    experienceStepLabel: "Intervalle d’expérience (années)",
    byMyBmiHint: "IMC = poids (kg) / taille² (m²), d'après la taille du profil et le poids saisi pour chaque match.",
    byMyBmiNone: "Aucune mesure de votre IMC. Ajoutez votre taille dans les paramètres et votre poids par match.",
    bmiBucketSize: "Intervalle d'IMC",
    bmiSmallSampleHint: "Appuie sur une barre pour voir les victoires et les matchs. Des intervalles très étroits avec peu de matchs restent peu fiables.",
    startTimeHalfHourHint: "Par créneaux de 30 minutes au début du match (18:30 couvre 18:30–18:59).",
    title: "Stats", subtitle: "Plongée dans les chiffres.",
    none: "Aucun match avec score.",
    allOpponents: "Tous les adversaires",
    gamesIServed: "Jeux de service", holdRateOnServe: "Taux de hold au service",
    gamesIReceived: "Jeux de retour", opponentHolds: "Holds de l'adversaire", breaksIDid: "Breaks réalisés",
    serviceStats: "Stats service", returnStats: "Stats retour",
    holds: "Holds", breaksAgainst: "Breaks (contre moi)", holdRate: "Taux de hold ({{n}} jeux)",
    breaksWon: "Breaks gagnés", breakRate: "Taux de break ({{n}} jeux de retour)",
    smartwatch: "Stats smartwatch", smartwatchHint: "Moyennes de vos captures.",
    avgKcal: "Calories moy.", avgDuration: "Durée moy.", avgBpm: "BPM moy.", maxBpm: "BPM max (moy)",
    perfReport: "Rapport de performance",
    perfHint: "Moyennes des évaluations (1–10).",
    perfNone: "Aucune évaluation pour le moment.",
    trendTitle: "Évolution du taux de victoire", h2h: "Face-à-face",
    byCourt: "Taux de victoire par court", byDay: "Par jour",
    bySurface: "Par surface", byTemp: "Par température",
    surfaceNone: "Aucune surface enregistrée.", tempNone: "Aucune température enregistrée.",
    perGame: "Réussite par jeu", set: "Set", scope: "Portée",
    scopeAll: "Global", scopeServing: "Service en premier", scopeReturning: "Retour en premier",
    metricWin: "Taux de victoire", metricHold: "Taux de hold (au service)",
    fullTab: "Complet", allSet: "Tous les sets",
    perGameHint: "Taux de réussite par numéro de jeu.",
    firstBreakTitle: "Taux de victoire selon le premier break", firstBreakHint: "Le premier break décide-t-il du résultat ?",
    fbMe: "J'ai breaké en premier", fbOpp: "L'adversaire a breaké en premier", allSurfaces: "Toutes les surfaces",
    firstServerTitle: "Taux de victoire selon le premier serveur", firstServerHint: "Le premier service influence-t-il le résultat ?",
    fsMatch: "Match entier", fsMe: "J'ai servi en premier", fsOpp: "L'adversaire a servi en premier",
    returnGames: "Jeux de retour", breakRateLabel: "Taux de break", gameNumber: "Jeu",
    hrZonesAvg: "Zones cardiaques moyennes",
    hrZonesAvgHint: "Minutes moyennes par zone sur {{n}} matchs avec données montre.",
    byYear: "Taux de victoire par année", byMonth: "Taux de victoire par mois",
    byCategoryKind: "Taux par catégorie & type",
    byOppAge: "Par âge de l'adversaire", byOppAgeHint: "Par tranche d'âge.", byOppAgeNone: "Pas d'âge enregistré.",
    byOppExp: "Par expérience de l'adversaire", byOppExpHint: "Années de tennis.", byOppExpNone: "Pas d'expérience enregistrée.",
    byOppLevel: "Taux de victoire par niveau de l'adversaire", byOppLevelHint: "Niveau global de l'adversaire (1–10).", byOppLevelNone: "Aucun niveau d'adversaire enregistré.",
    byOppBmi: "Par IMC de l'adversaire", byOppBmiHint: "Indice de Masse Corporelle = poids (kg) / taille² (m²).", byOppBmiNone: "Pas d'IMC adversaire enregistré. Ajoutez taille et poids pour voir ce graphique.",
    showTrend: "Afficher la tendance", hideTrend: "Masquer la tendance",
    byOppBackhand: "Par revers de l'adversaire", byOppBackhandNone: "Pas de revers enregistré.",
    byBalls: "Par état des balles", byBallsNone: "Pas d'état des balles enregistré.",
    ballsNew: "Neuves", ballsUsed: "Usées", ballsUsedN: "Usées ×{{count}}",

    byRainy: "Sous la pluie", byFloodlights: "Sous projecteurs",
    byDuration: "Par durée du match", byStartTime: "Par heure de début",
    byMyBmi: "Par mon IMC",
    byOppHandedness: "Par main de l'adversaire", byOppPlaystyle: "Par style de l'adversaire",
    byOppBirthMonth: "Taux de victoires par mois de naissance de l'adversaire",
    bySleep: "Par heures de sommeil", byTiringDay: "Après journée fatigante",
    byNapped: "Avec sieste", byHeavyMeal: "Après repas copieux",
    byFasted: "À jeun", byAnxious: "Avec anxiété",
    byCondition: "Par condition physique", byPartner: "Par partenaire",
    gameDetail: {
      whenServing: "Quand je servais", whenReturning: "Quand je retournais",
      held: "Service tenu", broken: "Break subi", opponentHeld: "Service adverse tenu", iBroke: "J'ai breaké",
      deuce: "Égalité", pressure: "Pression",
      serviceCoverage: "Détail enregistré pour {{detailed}} jeux de service sur {{total}}",
      returnCoverage: "Détail enregistré pour {{detailed}} jeux de retour sur {{total}}",
      smallSample: "Petit échantillon · n={{count}}",
      noServiceData: "Aucun jeu de service détaillé", noReturnData: "Aucun jeu de retour détaillé",
      unlock: "Ajoute le détail des jeux pendant la saisie pour voir cette répartition.",
      serviceTooltip: "{{percentage}} % · {{count}} jeux de service détaillés sur {{total}}",
      returnTooltip: "{{percentage}} % · {{count}} jeux de retour détaillés sur {{total}}",
      serviceHeld: { "0": "Service tenu avec le relanceur à 0", "15": "Service tenu avec le relanceur à 15", "30": "Service tenu avec le relanceur à 30", D: "Service tenu après égalité", DG: "Service tenu après avoir écarté une balle de break" },
      serviceBroken: { "0": "Break subi en restant à 0", "15": "Break subi en restant à 15", "30": "Break subi en restant à 30", D: "Break subi après égalité", DG: "Break subi après avoir eu une balle de jeu" },
      returnHeld: { "0": "Service adverse tenu avec moi à 0", "15": "Service adverse tenu avec moi à 15", "30": "Service adverse tenu avec moi à 30", D: "Service adverse tenu après égalité", DG: "Service adverse tenu après que j'ai eu une balle de break" },
      returnBreak: { "0": "Break réussi avec l'adversaire à 0", "15": "Break réussi avec l'adversaire à 15", "30": "Break réussi avec l'adversaire à 30", D: "Break réussi après égalité", DG: "Break réussi après que l'adversaire a eu une balle de jeu" },
    },
  },
  theme: { label: "Thème", court: "Court de nuit", clay: "Terre battue", daylight: "Lumière du jour", grass: "Gazon", hardcourt: "Dur" },
  insights: {
    pageSubtitle: "Analyse de vos matchs par IA.",
    pickOpponent: "Adversaire",
    title: "Insights", subtitle: "Tendances de tes données + coach IA.",
    askAi: "Demander à l'IA", generating: "Génération…", aiNarrative: "Analyse IA",
    notEnough: "Pas assez de données — continue d'enregistrer.",
    aiError: "Impossible de générer les insights.",
  },
  insightsPreview: {
    title: "Ce que Tennis Log va découvrir",
    subtitle: "Enregistre tes matchs et Tennis Log apprendra peu à peu les tendances derrière tes résultats.",
    learningTitle: "Ce que Tennis Log apprend ensuite",
    learningSubtitle: "Ces domaines nécessitent un peu plus d'historique avant de pouvoir en dire quoi que ce soit.",
    examplesLabel: "Exemples de ce que Tennis Log peut découvrir",
    badge: "Exemple",
    cta: "Enregistre ton premier match",
    disclaimer: "Ce sont des exemples illustratifs, pas des conclusions sur toi. Ils ne reposent pas sur tes données.",
    items: {
      serve: { text: "Tu es meilleur dans les matchs serrés quand ta première balle passe.", unlock: "Enregistre des notes de service sur quelques matchs pour le débloquer." },
      opponents: { text: "Tes résultats face aux adversaires plus forts s'améliorent.", unlock: "Enregistre quelques matchs de plus avec le niveau de l'adversaire pour le débloquer." },
      pressure: { text: "Tes fautes directes augmentent dans les sets sous pression.", unlock: "Enregistre quelques matchs de plus pour voir si la pression influence ta performance." },
      surface: { text: "Tu gagnes plus souvent sur une surface que sur une autre.", unlock: "Enregistre des matchs sur différentes surfaces pour le débloquer." },
    },
  },
  gaps: {
    title: "Ce que Tennis Log ne sait pas encore",
    subtitle: "Plus tes matchs sont complets, plus ton coach IA devient intelligent.",
    knowledgeTitle: "Connaissance IA",
    knowledgeHint: "Une estimation des informations utiles disponibles pour une analyse IA pertinente.",
    loggedIn: "Enregistré dans {{pct}}% de tes matchs.",
    notYet: "Pas encore de données.",
    couldReveal: "Tennis Log pourrait révéler :",
    cta: "Commencer à l'enregistrer",
    doneTitle: "Excellent !",
    doneBody: "Tennis Log dispose déjà d'assez de données pour des analyses IA de qualité. Continue à enregistrer tes matchs pour gagner en fiabilité et découvrir de nouvelles tendances.",
    items: {
      selfRatings: {
        label: "Tes propres évaluations",
        bullets: ["quels coups décident vraiment tes matchs", "comment ton niveau évolue selon les sets", "ta progression sur la saison"],
      },
      opponentRatings: {
        label: "Évaluations de l'adversaire",
        bullets: ["les forces qui comptent face aux joueurs plus forts", "les faiblesses visibles seulement à niveau égal", "une analyse de confrontation personnalisée"],
      },
      sleep: {
        label: "Sommeil",
        bullets: ["si le sommeil influence ton taux de victoires", "ton endurance", "ta performance au troisième set"],
      },
      nutrition: {
        label: "Nutrition",
        bullets: ["l'effet des repas sur la performance", "si les repas lourds réduisent ta régularité", "comment le jeûne change ton endurance"],
      },
      weather: {
        label: "Météo & conditions",
        bullets: ["l'effet du soleil, du vent ou de la pluie", "ta performance sous les projecteurs", "ta plage de température idéale"],
      },
      court: {
        label: "Court & balles",
        bullets: ["ta meilleure surface", "l'effet de l'état des balles sur ton rythme", "les lieux qui conviennent à ton jeu"],
      },
      emotions: {
        label: "Mental & énergie",
        bullets: ["l'effet du stress sur les sets serrés", "l'impact d'une journée fatigante", "quand le calme fait basculer un match"],
      },
      watch: {
        label: "Montre connectée",
        bullets: ["détection de la fatigue", "schémas de récupération", "corrélations fréquence cardiaque / intensité"],
      },
    },
  },
  composite: {
    title: "Insights composites",
    subtitle: "Des tendances qui n'apparaissent qu'en combinant plusieurs signaux de tes matchs.",
    disclaimer: "Les insights composites décrivent des corrélations dans tes données, pas des causes prouvées. Ils apparaissent seulement quand l'échantillon et l'écart sont suffisants.",
    showMore: "Voir {{count}} de plus",
    showLess: "Voir moins",
    direction: {
      positive: "Constat positif",
      negative: "Constat négatif",
      neutral: "Constat neutre",
    },
    cat: {
      momentum: "Dynamique & déroulé du match",
      context: "Performance selon le contexte",
      opponent: "Analyse des adversaires",
      physical: "Condition physique",
      development: "Progression",
      matchup: "Analyse des confrontations",
    },
    ev: {
      groups: "Tu as gagné {{aWins}} matchs sur {{aSample}} ({{aRate}}%) {{aLabel}}, contre {{bWins}} sur {{bSample}} ({{bRate}}%) {{bLabel}}.",
      single: "Tu as gagné {{aWins}} matchs sur {{aSample}} ({{aRate}}%).",
      ratingTrend: "Auto-évaluation moyenne de {{recentAvg}} sur tes {{recentN}} derniers matchs, contre {{prevAvg}} sur les {{prevN}} précédents.",
    },
    grp: {
      metricAbove: "quand tu t'es noté au-dessus de ta moyenne dans ce domaine : {{skill}}",
      metricBelow: "quand ta note était à ta moyenne ou en dessous",
      metricAboveSurface: "sur {{surface}} quand tu t'es noté au-dessus de ta moyenne dans ce domaine : {{skill}}",
      metricBelowSurface: "sur {{surface}} quand ta note était à ta moyenne ou en dessous",
      lostFirstSet: "après avoir perdu le premier set",
      wonFirstSet: "après avoir gagné le premier set",
      long: "dans les matchs de plus de 90 minutes",
      short: "dans les matchs de moins de 90 minutes",
      decider: "dans les matchs allés jusqu'au set décisif",
      overall: "sur l'ensemble de tes matchs enregistrés",
      tiebreak: "dans les matchs avec tie-break",
      surfaceOn: "sur cette surface : {{surface}}",
      surfaceOff: "sur les autres surfaces",
      morning: "dans les matchs du matin",
      afternoon: "dans les matchs de l'après-midi et du soir",
      floodlit: "sous les projecteurs",
      daylight: "à la lumière du jour",
      skillBetter: "quand tu t'es mieux noté sur ce point : {{skill}}",
      skillWorse: "quand l'adversaire était mieux noté sur ce point",
      goodSleepLong: "dans les longs matchs après 7 h de sommeil ou plus",
      lowSleepLong: "dans les longs matchs après moins de sommeil",
      goodSleepDecider: "dans les matchs à set décisif après 7 h de sommeil ou plus",
      lowSleepDecider: "dans les matchs à set décisif après moins de sommeil",
      heavyMeal: "après un repas lourd",
      noHeavyMeal: "sans repas lourd",
      recentPeriod: "sur tes {{n}} derniers matchs",
      previousPeriod: "sur les {{n}} matchs précédents",
      h2hLostFirst: "contre cet adversaire après un premier set perdu",
      h2hOverall: "contre cet adversaire au total",
    },
    msg: {
      mentalPressureStrong: "Dans les moments de pression, le mental décide : {{skill}} — {{wins}} victoires sur {{sample}} matchs de ce type ({{rate}}%) quand tu t'es noté au-dessus de ta moyenne, contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) sinon.",
      mentalPressureWeak: "Dans les moments de pression, le mental te coûte des matchs : {{skill}} — {{wins}} victoires sur {{sample}} ({{rate}}%) quand tu t'es noté au-dessus de ta moyenne, contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) sinon.",
      serveTightStrong: "Dans les sets serrés, ton service fait la différence : {{skill}} — {{wins}} victoires sur {{sample}} ({{rate}}%) quand tu t'es noté au-dessus de ta moyenne, contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) sinon.",
      serveTightWeak: "Les sets serrés révèlent une faiblesse au service : {{skill}} — {{wins}} victoires sur {{sample}} ({{rate}}%) quand tu t'es noté au-dessus de ta moyenne, contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) sinon.",
      techniqueSurfaceStrong: "Sur {{surface}}, un secteur décide du résultat : {{skill}} — {{wins}} victoires sur {{sample}} ({{rate}}%) quand tu t'es noté au-dessus de ta moyenne, contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) sinon.",
      techniqueSurfaceWeak: "Sur {{surface}}, un secteur te freine : {{skill}} — {{wins}} victoires sur {{sample}} ({{rate}}%) quand tu t'es noté au-dessus de ta moyenne, contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) sinon.",
      comebackStrong: "Tu renverses bien les matchs après un premier set perdu — {{wins}} victoires sur {{sample}} ({{rate}}%).",
      comebackWeak: "Tu peines actuellement à revenir après un premier set perdu — seulement {{wins}} victoires sur {{sample}} ({{rate}}%).",
      fadeLong: "Tu baisses dans les matchs longs — {{wins}} victoires sur {{sample}} matchs de plus de 90 minutes ({{rate}}%), contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) dans les plus courts.",
      thriveLong: "Les matchs longs te réussissent — {{wins}} victoires sur {{sample}} matchs de plus de 90 minutes ({{rate}}%), contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) dans les plus courts.",
      deciderStrong: "Tu hausses ton niveau dans les sets décisifs — {{wins}} victoires sur {{sample}} ({{rate}}%), au-dessus de tes {{baseline}}% globaux.",
      deciderWeak: "Les sets décisifs te coûtent des matchs — {{wins}} victoires sur {{sample}} ({{rate}}%), sous tes {{baseline}}% globaux.",
      tiebreakStrong: "Les tie-breaks tournent en ta faveur — {{wins}} victoires sur {{sample}} matchs avec tie-break ({{rate}}%), au-dessus de tes {{baseline}}% globaux.",
      tiebreakWeak: "Les tie-breaks te coûtent des matchs — {{wins}} victoires sur {{sample}} matchs avec tie-break ({{rate}}%), sous tes {{baseline}}% globaux.",
      surfaceStrong: "Cette surface te convient : {{surface}} — {{wins}} victoires sur {{sample}} matchs ({{rate}}%), contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) ailleurs.",
      surfaceWeak: "Cette surface est la plus difficile pour toi : {{surface}} — {{wins}} victoires sur {{sample}} matchs ({{rate}}%), contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) ailleurs.",
      morningBetter: "Le matin te réussit le mieux — {{wins}} sur {{sample}} ({{rate}}%), contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) plus tard dans la journée.",
      eveningBetter: "Tu joues mieux plus tard dans la journée — {{wins}} sur {{sample}} ({{rate}}%), contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) le matin.",
      floodlightsBetter: "Sous les projecteurs ton jeu tient mieux — {{wins}} sur {{sample}} ({{rate}}%), contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) en journée.",
      floodlightsWorse: "Les matchs sous projecteurs sont plus durs pour toi — {{wins}} sur {{sample}} ({{rate}}%), contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) en journée.",
      strongOppSkill: "Face aux adversaires plus forts, un domaine décide du match : {{skill}} — {{wins}} victoires sur {{sample}} ({{rate}}%) quand tu y étais mieux noté.",
      strongOppWeak: "Face aux adversaires plus forts, être mieux noté sur un domaine ne suffit pas : {{skill}} — {{wins}} victoires sur {{sample}} ({{rate}}%).",
      peerOppSkill: "Face aux adversaires de ton niveau, un domaine fait la différence : {{skill}} — {{wins}} victoires sur {{sample}} ({{rate}}%).",
      sleepLongMatches: "Dans les matchs longs, le sommeil se voit — {{wins}} victoires sur {{sample}} après 7 h ou plus ({{rate}}%), contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) avec moins.",
      fatigueThirdSet: "Dans les matchs allant au set décisif — {{wins}} victoires sur {{sample}} après 7 h de sommeil ou plus ({{rate}}%), contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) avec moins.",
      mealStrongOpp: "Face aux adversaires plus forts, un repas lourd se ressent — {{wins}} victoires sur {{sample}} sans repas lourd ({{rate}}%), contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) avec.",
      skillRising: "Un domaine progresse : {{skill}} — environ +{{diff}} points d'évaluation sur tes {{sample}} derniers matchs.",
      skillFalling: "Un domaine recule : {{skill}} — environ -{{diff}} points d'évaluation sur tes {{sample}} derniers matchs.",
      formUp: "Ta forme récente monte — {{wins}} victoires sur tes {{sample}} derniers matchs ({{rate}}%), contre {{otherWins}} sur les {{otherSample}} précédents ({{otherRate}}%), face à des adversaires de niveau comparable.",
      formDown: "Ta forme récente a baissé — {{wins}} victoires sur tes {{sample}} derniers matchs ({{rate}}%), contre {{otherWins}} sur les {{otherSample}} précédents ({{otherRate}}%), face à des adversaires de niveau comparable.",
      matchupSkill: "Contre {{opponent}}, un domaine décide des confrontations : {{skill}} — {{wins}} victoires sur {{sample}} ({{rate}}%) quand tu y étais mieux noté.",
      matchupFirstSet: "Contre {{opponent}}, un premier set perdu est difficile à renverser — {{wins}} victoires sur {{sample}} ({{rate}}%), contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) au total.",
      matchupComeback: "Contre {{opponent}}, un premier set perdu ne décide de rien — {{wins}} victoires sur {{sample}} ({{rate}}%), contre {{otherWins}} sur {{otherSample}} ({{otherRate}}%) au total.",
    },
  },
  coach: {
    driverTitle: "Facteur décisif",
    driverLead: "Un secteur décide la majorité de tes matchs, dans les deux sens : {{topic}}.",
    driverSupport: "Jusqu'ici : {{goodWins}} victoires sur {{goodSample}} matchs ({{goodRate}}%) quand ça marchait, contre {{badWins}} sur {{badSample}} ({{badRate}}%) sinon.",
    title: "Résumé du coach IA",
    subtitle: "L'essentiel de ce que Tennis Log a appris de tes matchs.",
    notEnough: "Pas encore assez de matchs pour conclure — continue à enregistrer.",
    strengthTitle: "Plus grande force",
    weaknessTitle: "Plus grande faiblesse",
    possibleStrengthTitle: "Force possible",
    possibleWeaknessTitle: "Axe d'amélioration possible",
    strengthLead: "Tes données indiquent ta plus grande force ici : {{topic}}.",
    weaknessLead: "Tes données indiquent ta plus grande faiblesse ici : {{topic}}.",
    strengthLeadTentative: "Premiers signes d'une force ici : {{topic}} — l'échantillon reste toutefois réduit.",
    weaknessLeadTentative: "Premiers signes d'un axe d'amélioration ici : {{topic}} — l'échantillon reste toutefois réduit.",
    focusTitle: "Objectif du prochain match",
    focusOne: "Pour ton prochain match, concentre-toi surtout ici : {{first}}.",
    focusTwo: "Pour ton prochain match, concentre-toi surtout ici : {{first}} — et garde comme arme fiable : {{second}}.",
    disclaimer: "Ce sont des tendances issues de tes propres données, pas des causes prouvées.",
    confidence: {
      high: "Fiabilité élevée",
      medium: "Fiabilité moyenne",
      low: "Fiabilité faible",
    },
  },
  watch: {
    uploadScreenshot: "Téléverser une capture", uploading: "Téléversement...", aiExtracting: "Extraction IA...",
    removeImage: "Supprimer l'image", imageRequired: "Choisissez une image (PNG/JPG)",
    uploadFailed: "Échec du téléversement", extractFailed: "Extraction IA échouée",
    extracted: "Données extraites de la capture !",
    sourcesHint: "Mi Fitness, Garmin, Apple Watch, Zepp, etc. Champs auto-remplis via IA.",
    multipleHint: "Tu peux importer plusieurs captures.",
    screenshotAlt: "Capture entraînement smartwatch",
    kcal: "Calories (kcal)", duration: "Durée (min)", avgBpm: "BPM moyen", maxBpm: "BPM max",
    hrZones: "Zones cardiaques", notes: "Notes montre", notesPlaceholder: "Effet entraînement, récupération, etc.",
  },
  surfaces: { hard: "Dur", clay: "Terre battue", grass: "Gazon", carpet: "Moquette" },
  ad: { label: "Publicité" },
  footer: {
    rights: "Tous droits réservés.",
    contact: "Contact", contactTitle: "Contacter Tennis Ledger",
    contactHint: "Envoyez-nous un message.",
    yourEmail: "Votre email", subject: "Sujet", message: "Message", send: "Ouvrir email",
  },
  install: {
    iosCta: "Installer sur iPhone",
    platforms: "Disponible sur Android · Fonctionne sur iPhone",
    iosSheetTitle: "Utilise Tennis Log comme une app",
    iosSheetIntro: "Ajoute Tennis Log à ton écran d'accueil en quelques gestes, sans App Store.",
    iosSheetStep1: "Ouvre Tennis Log dans Safari",
    iosSheetStep2: "Touche le bouton Partager",
    iosSheetStep3: "Touche « Sur l'écran d'accueil »",
    iosSheetStep4: "Touche « Ajouter »",
    iosReassurance: "Tennis Log apparaîtra sur ton écran d'accueil et s'ouvrira comme une app.",
    iosNonSafari: "Pour installer Tennis Log sur ton iPhone, ouvre cette page dans Safari.",
    iosNonSafariHint: "Ouvre le menu du navigateur et choisis « Ouvrir dans Safari », puis Partager → Sur l'écran d'accueil.",
    iosNudgeTitle: "Garde Tennis Log à portée de doigt",
    iosNudgeBody: "Ajoute Tennis Log à ton écran d'accueil pour une expérience d'application.",
    iosNudgeShowMe: "Montre-moi comment",
    iosNudgeDismiss: "Pas maintenant",
    cta: "Télécharger l'app",
    loading: "L'option d'installation se charge, patientez quelques secondes",
    opening: "Ouverture de l'invite d'installation…",
    unavailable: "L'option d'installation n'est pas disponible pour le moment",
    title: "Installer Tennis Log",
    hint: "Ajoutez Tennis Log à votre appareil pour l'ouvrir comme une vraie app.",
    iosStep1: "Appuyez sur Partager",
    iosStep2: "Puis choisissez « Sur l'écran d'accueil ».",
    iosStep3: "Appuyez sur « Ajouter » en haut à droite",
    androidStep1: "Appuyez sur le menu du navigateur ⋮",
    androidStep2: "Choisissez « Installer l'application » ou « Ajouter à l'écran d'accueil ».",
    androidStep3: "Confirmez l'installation",
    desktopHint: "Sur Chrome ou Edge desktop :",
    desktopStep1: "Cliquez sur l'icône d'installation dans la barre d'adresse",
    desktopStep2: "Ou ouvrez le menu du navigateur et choisissez « Installer Tennis Log ».",
  },

  profileSetup: {
    "title": "Complète ton profil de joueur",
    "subtitle": "Quelques informations rendent tes statistiques et analyses IA bien plus précises.",
    "dob": "Date de naissance",
    "level": "Ton niveau (1–10)",
    "levelHint": "1 = tu débutes, 10 = joueur de compétition de haut niveau.",
    "unitsMetric": "Métrique",
    "unitsUs": "US",
    "later": "Plus tard",
    "saved": "Profil mis à jour",
    "ctaTitle": "Complète ton profil de joueur",
    "ctaBody": "Une minute suffit pour affiner toutes les comparaisons de tes stats.",
    "ctaAction": "Compléter le profil",
    "countryPlaceholder": "Choisir un pays",
    "countrySearch": "Rechercher un pays…",
    "countryEmpty": "Aucun pays trouvé"
  },
  settings: {
    healthConsent: "Consentement aux données de santé",
    healthConsentActive: "Actif : vous autorisez Tennis Log à traiter les données de santé ajoutées à vos matchs.",
    healthConsentInactive: "Inactif : aucune donnée de montre ou de fréquence cardiaque n’est traitée.",
    healthConsentWithdraw: "Retirer le consentement",
    healthConsentWithdrawn: "Consentement retiré et données de santé supprimées.",
    healthConsentPartial: "Consentement retiré. Certaines données de santé n’ont pas encore pu être supprimées — réessayez sous peu.",
    healthConsentError: "Impossible de mettre à jour votre consentement. Réessayez.",
    healthConsentWithdrawHint: "Retirer le consentement supprimera définitivement les captures d’écran de montre connectée et les données de santé importées (fréquence cardiaque, calories, etc.).",
    healthConsentWithdrawTitle: "Retirer le consentement aux données de santé ?",
    healthConsentWithdrawBody: "Cela supprimera définitivement les captures d’écran de montre connectée et les données de santé importées, y compris la fréquence cardiaque et les calories enregistrées avec vos matchs. Cette action est irréversible.",
    healthConsentWithdrawKeepMatches: "Vos fiches de matchs resteront intactes ; seules les captures et les données de santé stockées seront supprimées.",
    healthConsentWithdrawConfirm: "Retirer le consentement et supprimer les données de santé",
    title: "Paramètres",
    profile: "Profil",
    displayName: "Nom affiché",
    age: "Âge",
    country: "Pays",
    gender: "Sexe",
    gender_male: "Homme", gender_female: "Femme", gender_other: "Autre", gender_prefer_not: "Préfère ne pas dire",
    level: "Niveau de tennis",
    level_beginner: "Débutant", level_intermediate: "Intermédiaire", level_advanced: "Avancé", level_competitive: "Compétition",
    profileSaved: "Profil enregistré",
    password: "Mot de passe",
    newPassword: "Nouveau mot de passe",
    changePassword: "Changer le mot de passe",
    pwdTooShort: "Le mot de passe doit faire au moins 6 caractères",
    pwdChanged: "Mot de passe modifié",
    dataExport: "Export des données",
    dataExportHint: "Téléchargez vos {{count}} matchs en CSV.",
    exportCsv: "Exporter en CSV",
    noMatchesExport: "Aucun match à exporter.",
    exported: "{{count}} matchs exportés",
    units: "Unités",
    unitsHint: "Choisissez l'affichage des températures et des poids. Vos données sont toujours stockées en °C et kg.",
    unitsMetric: "Métrique (°C, kg)",
    unitsUs: "US (°F, lb)",
    cookiePrefs: "Préférences cookies",
    cookiePrefsHint: "Mettez à jour les catégories de cookies autorisées.",
    manageCookies: "Gérer les cookies",
    diagnostics: "Application et diagnostics",
    diagnosticsHint: "Détails techniques qui nous aident à reproduire un problème. Rien de personnel n'est inclus.",
    diagnosticsCopy: "Copier les diagnostics",
    diagnosticsCopied: "Diagnostics copiés dans le presse-papiers",
    diagnosticsCopyFailed: "Échec de la copie — réessayez",
    reportProblem: "Signaler un problème",
    diagnosticsPasted: "Diagnostics copiés — collez-les dans votre message.",
    diagLanguage: "Langue",
    diagUnits: "Unités",
    diagDisplay: "Mode d'affichage",
    diagDisplayStandalone: "Application installée (autonome)",
    diagDisplayBrowser: "Onglet du navigateur",
    diagBrowser: "Navigateur",
    diagViewport: "Fenêtre d'affichage",
    diagOrientation: "Orientation",
    diagHostname: "Nom d'hôte",
    dangerZone: "Zone dangereuse",
    deleteAccount: "Supprimer mon compte",
    deleteHint: "Supprime définitivement votre compte et toutes vos données. Action irréversible.",
    deleteConfirmTitle: "Supprimer le compte ?",
    deleteConfirmDesc: "Tous vos matchs, données de profil et identifiants seront supprimés définitivement.",
    deleteForever: "Oui, supprimer",
    accountDeleted: "Compte supprimé",
    handedness: "Main", righty: "Droitier", lefty: "Gaucher", heightCm: "Taille ({{unit}})",
  },
  cookies: {
    title: "Votre vie privée",
    intro: "Nous utilisons des cookies pour faire fonctionner l'app et mesurer l'usage. Choisissez ce que vous autorisez.",
    necessary: "Strictement nécessaires",
    necessaryDesc: "Requis pour la connexion et les fonctions de base. Toujours actifs.",
    analytics: "Analyses",
    analyticsDesc: "Statistiques anonymes d'utilisation pour améliorer l'app.",
    marketing: "Marketing",
    marketingDesc: "Utilisés par les réseaux publicitaires pour personnaliser.",
    acceptAll: "Tout accepter",
    rejectAll: "Tout refuser",
    customize: "Personnaliser",
    savePrefs: "Enregistrer",
  },
  invite: {
    title: "Inviter un ami",
    subtitle: "Partagez My Tennis Ledger — scannez le QR ou copiez le lien.",
    copyLink: "Copier le lien",
    share: "Partager",
    copied: "Lien copié !",
    shareText: "Suivez votre histoire au tennis avec My Tennis Ledger :",
  },
  help: {
    eyebrow: "Centre d'aide",
    title: "Comment fonctionne Tennis Log",
    subtitle: "Une visite rapide de chaque fonctionnalité, avec captures d'écran et astuces. Cliquez sur une section pour y accéder.",
    tocTitle: "Sur cette page",
    tocTroubleshooting: "Dépannage",
    tocWhoFor: "À qui s'adresse Tennis Log ?",
    tocAbout: "À propos de Tennis Log",
    s1Title: "Premiers pas",
    s1Body: "Créez un compte avec e-mail ou Google. Vous arriverez sur le Tableau de bord — vide pour l'instant. Touchez « + Nouveau match » pour enregistrer le premier.",
    s2Title: "Le Tableau de bord",
    s2Body: "Six résumés en haut : Taux de victoire, Sets, Jeux, Hold rate, Breaks gagnés et Forme actuelle. Chacun reflète le filtre actuel (année, format, type). En dessous : tendance du taux de victoire et matchs récents.",
    s3Title: "Ajouter un match",
    s3Body: "Dans New Match, commencez par enregistrer l’adversaire, le court et le score afin de ne pas perdre le résultat. Utilisez ensuite Score Timeline, Opponent, Context, Performance Review et Smartwatch pour ajouter uniquement le niveau de détail dont vous vous souvenez réellement. Vous pouvez sauvegarder d’abord le match essentiel et revenir plus tard enrichir le même enregistrement.",
    s4Title: "Liste des matchs",
    s4Body: "Recherche par adversaire, filtres par format et type, cliquez sur une ligne pour modifier. Actions groupées et export CSV dans les Paramètres.",
    s5Title: "Stats",
    s5Body: "Analyse approfondie : face-à-face, par court, par surface, par température, par année/mois, par âge & expérience de l'adversaire, par état des balles, même par pluie ou projecteurs.",
    s6Title: "Insights IA",
    s6Body: "Cliquez sur « Ask AI » pour obtenir une analyse de type coach basée sur votre historique de matchs. L’analyse IA est disponible dès que vous avez enregistré des données de match et devient généralement plus informative à mesure que votre historique s’enrichit. Lorsque vous demandez des AI Insights, seules des données de match autorisées et filtrées pour protéger la vie privée sont envoyées ; les identifiants personnels sont supprimés ou pseudonymisés conformément à la Politique de confidentialité.",
    s7Title: "Import Smartwatch",
    s7Body: "Sur la page Nouveau match, faites défiler jusqu'à « Données smartwatch », chargez une capture d'écran de votre app et nous remplirons automatiquement kcal, durée, BPM moy/max et zones FC via IA.",
    s8Title: "Export & suppression",
    s8Body: "Depuis les Paramètres, changez votre mot de passe, gérez les cookies, exportez tout en CSV, ou supprimez définitivement votre compte.",
    ctaTitle: "Prêt à commencer ?",
    ctaDesc: "Rapide et simple — vous verrez vos premières stats après un match.",
    ctaBtn: "Créer votre compte",
    troubleshootingTitle: "Dépannage",
    troubleshootingItems: [
      { q: "Je ne peux pas me connecter", a: "Assurez-vous d'utiliser le même fournisseur avec lequel vous vous êtes inscrit (email ou Google). Si vous avez oublié votre mot de passe, utilisez le lien de réinitialisation sur l'écran de connexion. Toujours bloqué ? Utilisez le lien Contact dans le pied de page avec l'email utilisé." },
      { q: "Mon match n'a pas été enregistré", a: "Pour enregistrer un match, un adversaire et un court sont requis. Les scores et les détails supplémentaires peuvent être ajoutés progressivement. Si vous voyez un message d’erreur rouge, le formulaire indique le champ manquant. Des problèmes de réseau peuvent aussi bloquer l’enregistrement — réessayez avec une connexion stable." },
      { q: "Les AI insights ne se génèrent pas", a: "Les AI insights ont besoin d'au moins quelques matchs enregistrés pour trouver des motifs. Si vous avez assez de données mais voyez encore une erreur, le service IA peut être temporairement limité — attendez une minute et réessayez." },
      { q: "La capture du smartwatch n'est pas analysée", a: "L'analyseur fonctionne mieux avec des captures claires et contrastées d'Apple Watch, Garmin, Polar ou Fitbit. Recadrez près du résumé d'entraînement et assurez-vous que le texte de fréquence cardiaque et durée est lisible." },
      { q: "Les chiffres des stats semblent faux", a: "La plupart des surprises viennent d'un ordre de service manquant dans les matchs game-by-game — sans lui, l'app ne peut pas calculer holds et breaks. Modifiez le match et vérifiez qui a servi en premier dans chaque set." },
    ],
    whoTitle: "À qui s'adresse Tennis Log ?",
    whoIntro: "Tennis Log est conçu pour tout joueur qui veut prendre son tennis un peu plus au sérieux que simplement se rappeler du score sur le chemin du retour. Il fonctionne aussi bien que vous jouiez depuis trois mois ou trois décennies — la profondeur de l'outil évolue avec la profondeur de votre journal de matchs.",
    whoBeginnersTitle: "Débutants",
    whoBeginnersBody: "Si vous venez de commencer, ce que Tennis Log vous apporte de plus utile est un enregistrement simple et structuré de vos premiers matchs. Pas besoin de suivre holds et breaks tout de suite. Notez juste l'adversaire, le score, la surface et une note d'une ligne. Après 10-15 matchs, vous aurez une base à laquelle vous référer six mois plus tard pour dire « je suis clairement meilleur maintenant », avec des preuves.",
    whoIntermediateTitle: "Joueurs intermédiaires",
    whoIntermediateBody: "Pour les joueurs de club et de ligue, Tennis Log est particulièrement utile. Le suivi game-by-game fournit de vrais pourcentages de hold et de break. L’analyse IA est disponible dès que vous avez enregistré des données de match et devient généralement plus informative à mesure que votre historique s’enrichit. Les filtres de surface et d’adversaire aident à examiner les différences, et un journal structuré peut fournir des questions plus précises à travailler à l’entraînement ou avec un coach.",
    whoCompetitiveTitle: "Joueurs compétitifs",
    whoCompetitiveBody: "Si vous jouez en tournois ou en ligue sérieuse, Tennis Log fonctionne comme une base de données personnelle de performance. Suivez conditions, main de l'adversaire, notations des deux côtés, données smartwatch, notes mentales — et découpez les stats par année, surface, type (amical vs officiel), partenaire et plus. Exportez en CSV à tout moment et apportez les données à une séance avec votre entraîneur.",
  },
  landing: {
    heroEyebrow: "Le journal de tennis intelligent",
    heroTitle: "Arrêtez de deviner. Étudiez votre tennis.",
    heroDesc: "Tennis Log est un beau journal pour les joueurs amateurs et compétitifs. Enregistrez chaque match, consultez des statistiques approfondies et laissez l'IA repérer les schémas qui vous freinent.",
    featuresTitle: "Tout ce qu'il vous faut, rien de superflu",
    f1Title: "Enregistrez chaque match en quelques secondes",
    f1Desc: "Score par set, adversaire, court, surface, météo, même vos doubles fautes — les menus déroulants rendent tout simple.",
    f2Title: "Des statistiques qui ont vraiment du sens",
    f2Desc: "% de victoires, % de jeux de service tenus, % de breaks, sets, jeux, performance par surface, court et adversaire.",
    f3Title: "Insights IA",
    f3Desc: "Recevez une analyse de coach personnel — vos forces, faiblesses et schémas repérés dans tout votre historique.",
    f4Title: "Import depuis smartwatch",
    f4Desc: "Déposez une capture d'écran de Mi Fitness, Garmin, Apple Watch ou Zepp — l'IA remplit calories, BPM et zones de FC pour vous.",
    f5Title: "Suivi jeu par jeu",
    f5Desc: "Vous voulez aller plus loin ? Enregistrez les séquences point par point et découvrez vos taux de réussite par jeu.",
    f6Title: "7 langues",
    f6Desc: "EN · EL · ES · FR · DE · IT · JA — votre historique de tennis dans votre langue.",
    previewTitle: "Un aperçu intérieur",
    shotDashLabel: "Tableau de bord", shotDashTitle: "Votre saison en un coup d'œil",
    shotDashDesc: "Six résumés racontent l’histoire : taux de victoire, sets, jeux, taux de hold, breaks gagnés et Forme actuelle. Chacun reflète les filtres sélectionnés.",
    shotAddLabel: "Ajouter un match", shotAddTitle: "Enregistrez un match en moins d'une minute",
    shotAddDesc: "Commencez par Fast Track pour enregistrer l’essentiel, puis ajoutez les détails souhaités via Score Timeline, Opponent, Context, Performance Review et Smartwatch.",
    shotStatsLabel: "Stats", shotStatsTitle: "Plongée profonde dans les chiffres",
    shotStatsDesc: "Simple vs double, amical vs officiel, % de jeux de service tenus, % de breaks, jeux de retour — chaque stat à votre façon.",
    shotTrendLabel: "Tendance des victoires", shotTrendTitle: "Voyez votre forme évoluer",
    shotTrendDesc: "Filtrez par simple, double, amical ou officiel — et regardez votre % de victoires glissant changer match après match.",
    shotPerfLabel: "Performance", shotPerfTitle: "Notez-vous et notez votre adversaire",
    shotPerfDesc: "Notez coup droit, revers, service, retour, volée, amortie, lob, endurance, vitesse et tactique — pour les deux côtés — et voyez-les sur un graphique radar.",
    shotPerGameLabel: "Réussite par jeu", shotPerGameTitle: "Trouvez votre jeu faible",
    shotPerGameDesc: "Découvrez si vous craquez au jeu 3 ou si vous concluez le jeu 11 — décomposé par côté de service et set.",
    shotWatchLabel: "Smartwatch", shotWatchTitle: "Cœur, calories, zones — automatique",
    shotWatchDesc: "Téléchargez une capture d'écran de l'app de votre montre et l'IA remplit calories, durée, BPM moyen, BPM max et zones de FC.",
    howTitle: "Comment ça marche",
    s1Title: "Ajoutez un match", s1Desc: "Touchez « + Nouveau match », remplissez score, adversaire et conditions. Moins d'une minute.",
    s2Title: "Regardez vos stats grandir", s2Desc: "Votre tableau de bord se met à jour instantanément. Filtrez par année, format, type — comme vous voulez.",
    s3Title: "Demandez au coach IA", s3Desc: "Après ~10 matchs, les Insights IA repèrent des schémas : où vous craquez, où vous brillez.",
    s4Title: "Améliorez-vous, match après match", s4Desc: "Identifiez ce qui marche et redoublez. Exportez en CSV à tout moment.",
    trust1Title: "Privé et sécurisé", trust1Desc: "Vos données sont les vôtres. Chiffrées, jamais vendues.",
    trust2Title: "Conçu pour les joueurs", trust2Desc: "Conçu par des joueurs de tennis, pour des joueurs de tennis.",
    trust3Title: "Le vôtre, en 7 langues", trust3Desc: "EN · EL · ES · FR · DE · IT · JA.",
    faqTitle: "Questions fréquentes",
    faq1Q: "Combien coûte Tennis Log ?", faq1A: "Aujourd'hui, toutes les fonctionnalités sont disponibles gratuitement — financées par de petites publicités. Nous pourrions introduire des forfaits payants optionnels à l'avenir pour des fonctions avancées.",
    faq2Q: "Dois-je enregistrer chaque point ?", faq2A: "Pas du tout. L'enregistrement le plus rapide est juste date + adversaire + scores des sets. Le suivi jeu par jeu est optionnel.",
    faq3Q: "Comment fonctionne l'import smartwatch ?", faq3A: "Prenez une capture d'écran du résumé de votre entraînement dans n'importe quelle app de montre, téléchargez-la et notre IA extrait calories, durée, BPM moyen et max, plus zones de FC.",
    faq4Q: "Puis-je exporter mes données ?", faq4A: "Oui — exportez tout en CSV à tout moment depuis les Paramètres.",
  },
}

data.insightsH = {
  "overall": "Taux de victoire global",
  "overallDetail": "{{rate}}% sur {{sample}} matchs décidés.",
  "better": "Meilleur {{skill}} que l'adversaire",
  "betterDetail": "Quand vous êtes meilleur en {{skill}}, vous gagnez {{rate}}% ({{sample}} matchs). Référence : {{baseline}}%.",
  "worse": "Plus faible {{skill}} que l'adversaire",
  "worseDetail": "Quand vous êtes plus faible en {{skill}}, vous gagnez {{rate}}% ({{sample}} matchs).",
  "condDetail": "{{rate}}% sur {{sample}} matchs (réf. {{baseline}}%).",
  "cond": {
    "oneHanded": "Vs revers à une main",
    "twoHanded": "Vs revers à deux mains",
    "lowSleep": "Peu de sommeil (<6h)",
    "goodSleep": "Bon sommeil (≥7h)",
    "tiring": "Journée fatigante",
    "floodlights": "Sous projecteurs",
    "rainy": "Temps pluvieux",
    "napped": "Sieste à midi",
    "heavyMeal": "Repas lourd",
    "fasted": "À jeun",
    "anxious": "Anxieux",
    "newBalls": "Balles neuves",
    "official": "Matchs officiels",
    "friendly": "Matchs amicaux",
    "singles": "Simples",
    "doubles": "Doubles",
    "surface": "Surface : {{surface}}"
  },
  "skill": {
    "shot_accuracy": "précision des frappes",
    "call_accuracy": "précision des annonces",
    "confrontational_tendency": "calme face à l'adversaire",
    "forehand": "coup droit",
    "backhand": "revers",
    "service": "service",
    "return": "retour",
    "volley": "volée",
    "drop_shot": "amortie",
    "lob": "lob",
    "stamina": "endurance",
    "speed": "vitesse",
    "unforced_errors": "maîtrise des fautes directes",
    "winners": "coups gagnants",
    "tactics": "tactique",
    "awareness": "lecture du jeu",
    "shot_variety": "variété des coups",
    "court_coverage": "couverture du terrain",
    "fh_topspin": "lift en coup droit",
    "fh_slice": "slice en coup droit",
    "bh_topspin": "lift en revers",
    "bh_slice": "slice en revers",
    "first_serve": "1re balle",
    "first_serve_pct": "pourcentage de 1re balle",
    "first_serve_speed": "vitesse de 1re balle",
    "second_serve": "2e balle",
    "second_serve_pct": "pourcentage de 2e balle",
    "second_serve_speed": "vitesse de 2e balle",
    "serve_flat": "service à plat",
    "serve_kick": "service kické",
    "serve_slice": "service slicé",
    "smash": "smash",
    "passing_shots": "passings",
    "composure": "sang-froid",
    "concentration": "concentration",
    "calmness": "calme",
    "anxiety": "gestion du stress",
    "confidence": "confiance",
    "fighting_spirit": "combativité",
    "mental_resilience": "résilience mentale",
    "belief_pre": "confiance avant le match",
    "belief_in": "confiance pendant le match"
  }
};
data.days = ["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"];

data.quicklog = {
  "learnedAccordion": "Voir ce que Tennis Log a appris jusqu'ici",
  "savedIndicator": "Enregistré",
  "fastTrackEyebrow": "Voie Rapide",
  "fastTrackTagline": "Enregistrez un match en moins de 30 secondes.",
  "revealMore": "Envie de réponses plus riches ? Découvrez plus ci-dessous ↓",
  "bonus": "Bonus",
  "continue": "Continuer",
  "meterTitle": "Désormais, Tennis Log peut calculer :",
  "meterSubtitle": "Ces analyses sont disponibles dès aujourd'hui, à partir des matchs enregistrés.",
  "meterMoreTitle": "Révélez plus pour répondre",
  "meterInfoAria": "À propos de ces analyses",
  "editScore": "Modifier le score",
  "timelineNoScore": "Aucun score saisi pour le moment",
  "answers": {
    "winRate": "Taux de victoires global",
    "history": "Historique des matchs",
    "gamesPct": "% de jeux gagnés",
    "setsPct": "% de sets gagnés",
    "monthly": "Taux de victoires par mois",
    "dayOfWeek": "Taux de victoires par jour de la semaine",
    "headToHead": "Confrontations contre ce joueur"
  },
  "future": {
    "opponent": "Quels profils d'adversaires conviennent à votre jeu",
    "timeline": "Comment vos matchs se déroulent vraiment",
    "context": "Quelles conditions vous aident à jouer votre meilleur tennis",
    "review": "Quelles de vos qualités vous font gagner",
    "watch": "Ce que votre montre dit de votre effort"
  },
  "stepTitles": {
    "fastTrack": "Voie Rapide",
    "opponent": "Adversaire",
    "timeline": "Déroulé du score",
    "context": "Contexte & Conditions",
    "review": "Évaluez votre performance",
    "watch": "Smartwatch"
  },
  "stepIntros": {
    "opponent": "Ajoutez des détails sur l'adversaire pour que Tennis Log construise une image plus riche de qui vous affrontez. Cela rend possible une analyse plus poussée.",
    "timeline": "Enregistrez comment chaque set s'est déroulé. Cela rend possible une analyse plus poussée de vos schémas de match.",
    "context": "Capturez les conditions du match. Cela rend possible une analyse plus poussée du contexte.",
    "review": "Évaluez votre propre performance. Cela rend possible une analyse plus poussée de vos qualités.",
    "watch": "Une montre connectée ? Téléversez une capture et laissez l'IA tout remplir automatiquement."
  },
  "stepUnlocksLabel": "Vous nourrirez l'analyse pour :",
  "unlocks": {
    "opponent": [
      "Résultats contre les gauchers",
      "Résultats contre les joueurs expérimentés",
      "Résultats par style de jeu adverse",
      "Résultats contre les revers à une main"
    ],
    "timeline": [
      "Comment vous gagnez et perdez vos sets",
      "Schémas de break et de hold",
      "Constance du service entre les sets"
    ],
    "context": [
      "Comment les conditions influent sur votre jeu",
      "Si le sommeil ou le repos changent les résultats",
      "Comment la météo se relie à vos performances"
    ],
    "review": [
      "Quelles qualités corrèlent avec vos victoires",
      "Quelles faiblesses vous coûtent des matchs",
      "Comment vos notes évoluent dans le temps"
    ],
    "watch": [
      "Calories et durée",
      "Fréquence cardiaque moyenne et max",
      "Charge d'entraînement et récupération"
    ]
  },
  "successTitle": "Match enregistré.",
  "successBody": "Tennis Log peut déjà répondre à ces questions sur votre tennis :",
  "successCtaMatches": "Voir mes matchs",
  "successCtaContinue": "Ajouter plus de détails au match — facultatif",

  "addMoreDetails": "Ajouter plus de détails",
  "finish": "Terminer et enregistrer",
  "wantRicher": "Envie de réponses plus riches ?",
  "prev": "Retour",
  "stepOf": "Étape {{current}} sur {{total}}",
  "dontShowRewards": "Ne plus afficher",
  "canLabel": "Tennis Log peut déjà identifier :",
  "learnedLabel": {
    "match": "Ce que Tennis Log a appris de ce match :",
    "matches": "Ce que Tennis Log a appris de vos matchs :",
    "tennis": "Ce que Tennis Log sait de votre tennis :"
  },
  "hintLabel": "Vous avez encore une minute ?",
  "rewardTitles": {
    "fastTrack": "Match enregistré !",
    "timeline": "Excellent !",
    "opponent": "Très bien !",
    "context": "Bien joué !",
    "review": "Fantastique !"
  },
  "rewardBodies": {
    "fastTrack": "Votre match fait maintenant partie de votre historique tennis.",
    "timeline": "Tennis Log comprend bien mieux comment se déroulent vos matchs.",
    "opponent": "Tennis Log en sait bien plus sur les joueurs que vous affrontez.",
    "context": "Tennis Log peut désormais relier votre performance aux conditions de jeu.",
    "review": "Votre auto-évaluation donne à Tennis Log une riche source d'analyse long terme."
  },
  "rewardHints": {
    "fastTrack": "Complétez l'étape suivante et Tennis Log commencera à découvrir :",
    "timeline": "Ensuite vous aiderez Tennis Log à comprendre vos adversaires.",
    "opponent": "Ensuite vous enregistrerez les conditions du match.",
    "context": "✨ Tu as encore une minute ? Évaluons maintenant la performance des deux joueurs.",
    "review": "Une dernière étape optionnelle : connectez votre smartwatch."
  }
};

// --- Progressive logging refinement (conversation-first copy) ---
Object.assign(data.match, {
  "oppGender": "Genre de l'adversaire *",
  "genderMale": "Homme",
  "genderFemale": "Femme",
  "genderOther": "Autre",
  "oppLevel": "Niveau global de l'adversaire",
  "oppLevel1": "Débutant complet",
  "oppLevel5": "Joueur de club moyen",
  "oppLevel10": "Le meilleur affronté",
  "oppLevelHint": "7 = bon joueur de club · 9 = niveau tournoi",
  "oppBirthYear": "Année de naissance",
  "oppBirthMonth": "Mois",
  "oppBirthDay": "Jour",
  "oppTennisSince": "Joue au tennis depuis (année)",
  "oppTennisSinceCompact": "Joue depuis",
  "oppLegacyValue": "enregistré auparavant",
  "oppBirthInvalid": "Saisis une année de naissance complète à 4 chiffres (à partir de 1900).",
  "oppAgePrev": "Âge enregistré précédemment",
  "oppExperiencePrev": "Années d'expérience enregistrées précédemment",
  "oppSinceBeforeBirth": "L'année de début du tennis ne peut pas précéder l'année de naissance.",
  "oppSinceFuture": "L'année de début du tennis ne peut pas être dans le futur.",
  "oppSinceRange": "Saisis une année complète à 4 chiffres (à partir de 1900).",
  "oppStyleScore": "Défensif ↔ offensif",
  "oppStyleLegacy": "Enregistré auparavant comme : {{value}}",
  "oppLevelAvg": "Moyenne des matchs précédents : {{value}} ({{n}})",
  "oppLevelHistory": "Historique du niveau",
  "oppAttackTags": "Comment il m'a fait mal",
  "oppErrorTags": "Où il faute",
  "oppTagRemembered": "Vu lors d'un match précédent",
  "attackGroup_serve": "Service & première frappe",
  "attackGroup_shape": "Type de frappe",
  "attackGroup_target": "Ciblage",
  "errorGroup_technical": "Technique",
  "errorGroup_situational": "Situationnel",
  "attackTag_big_first_serve": "Gros premier service",
  "attackTag_aggressive_return": "Retour agressif",
  "attackTag_serve_volley": "Service-volée",
  "attackTag_takes_ball_early": "Prend la balle tôt",
  "attackTag_heavy_topspin": "Lift lourd",
  "attackTag_frequent_slice": "Slice fréquent",
  "attackTag_drop_shots": "Amorties",
  "attackTag_short_angles": "Angles courts",
  "attackTag_effective_lobs": "Lobs efficaces",
  "attackTag_attacks_my_backhand": "Attaque mon revers",
  "attackTag_attacks_my_forehand": "Attaque mon coup droit",
  "attackTag_net_rusher": "Monte au filet",
  "attackTag_open_court": "Ouvre le court",
  "attackTag_changes_direction": "Change de direction",
  "errorTag_backhand_breaks_down": "Revers qui craque",
  "errorTag_forehand_breaks_down": "Coup droit qui craque",
  "errorTag_high_balls": "En difficulté sur les balles hautes",
  "errorTag_low_balls": "En difficulté sur les balles basses",
  "errorTag_vs_heavy_topspin": "En difficulté face au lift lourd",
  "errorTag_vs_slice": "En difficulté face au slice",
  "errorTag_vs_drop_shots": "En difficulté sur les amorties",
  "errorTag_volley_errors": "Fautes de volée",
  "errorTag_return_errors": "Fautes de retour",
  "errorTag_second_serve_errors": "Deuxième service faible",
  "errorTag_errors_when_rushed": "Fautes quand il est pressé",
  "errorTag_errors_on_the_run": "Fautes en course",
  "errorTag_overhits": "Frappe trop fort",
  "errorTag_long_rallies": "Fautes dans les longs échanges",
  "errorTag_under_pressure": "Fautes sous pression",
  "oppLevelEmpty": "Faites glisser pour évaluer le niveau global de l'adversaire.",
  "oppLevelDesc_10": "Débutant complet",
  "oppLevelDesc_15": "Commence tout juste à apprendre",
  "oppLevelDesc_20": "Débutant avec peu d'expérience en match",
  "oppLevelDesc_25": "Développe une régularité de base",
  "oppLevelDesc_30": "Joueur loisir occasionnel",
  "oppLevelDesc_35": "Joueur loisir en progression",
  "oppLevelDesc_40": "Joueur loisir régulier",
  "oppLevelDesc_45": "Joueur loisir solide",
  "oppLevelDesc_50": "Joueur de club moyen",
  "oppLevelDesc_55": "Joueur de club compétitif",
  "oppLevelDesc_60": "Joueur de club fort",
  "oppLevelDesc_65": "Joueur de club très fort",
  "oppLevelDesc_70": "Joueur de club avancé",
  "oppLevelDesc_75": "Joueur fort en compétition locale",
  "oppLevelDesc_80": "Joueur de tournoi de haut niveau",
  "oppLevelDesc_85": "Joueur de tournoi très fort",
  "oppLevelDesc_90": "Amateur d'élite / niveau régional",
  "oppLevelDesc_95": "Joueur exceptionnel",
  "oppLevelDesc_100": "Le meilleur joueur que j'aie affronté",
  "oppAttackNotes": "Comment cet adversaire attaque-t-il ?",
  "oppAttackNotesPlaceholder": "p. ex. gros service, prend la balle tôt…",
  "oppErrorNotes": "Comment cet adversaire commet-il ses erreurs ?",
  "oppErrorNotesPlaceholder": "p. ex. en difficulté quand on presse son revers…"
});
data.quicklog.stepTitles.review = "Évaluation des joueurs";
Object.assign(data.quicklog.stepIntros, {
  "fastTrack": "Juste l'essentiel — environ 30 secondes.",
  "timeline": "Comment le match s'est-il déroulé ?",
  "opponent": "Parlez-nous un peu de votre adversaire.",
  "context": "Les détails font la différence.",
  "review": "Évaluez la performance des deux joueurs — avec le temps, Tennis Log découvrira ce qui fait vos victoires.",
  "watch": "Vous avez une montre connectée ? Laissez Tennis Log compléter le reste."
});
Object.assign(data.quicklog.rewardTitles, {
  "fastTrack": "Parfait !",
  "timeline": "Excellent !",
  "opponent": "Superbe !",
  "context": "Parfait !",
  "review": "Excellent travail !",
  "watch": "Tout est prêt !"
});
Object.assign(data.quicklog.rewardBodies, {
  "fastTrack": "Votre match fait désormais partie de votre histoire de tennis.",
  "timeline": "Tennis Log comprend bien mieux comment vos matchs se déroulent.",
  "opponent": "Tennis Log en sait beaucoup plus sur les adversaires que vous affrontez.",
  "context": "Votre base de données personnelle vient de devenir plus intelligente : Tennis Log relie votre performance aux conditions de jeu.",
  "review": "Votre profil de joueur s'est enrichi, celui de votre adversaire aussi. Tennis Log peut commencer à découvrir quelles qualités vous font gagner.",
  "watch": "Vous venez de créer l'un des enregistrements de match les plus complets de votre parcours. Merci d'aider Tennis Log à comprendre votre tennis."
});

data.guest = {
  "tryNow": "Essayez maintenant — sans compte",
  "tryNowLine1": "Essayez maintenant",
  "tryNowLine2": "Sans compte",
  "badge": "Session invité",
  "sumScore": "Score",
  "sumType": "Type de match",
  "saveTitle": "Votre premier match est prêt.",
  "saveSubtitle": "Vous avez déjà enregistré votre premier match. Créez un compte gratuit pour le conserver et commencer votre historique tennis.",
  "canTitle": "Tennis Log peut déjà calculer",
  "beginningTitle": "Ce n'est que le début.",
  "beginningBody": "Continuez et Tennis Log apprendra bien plus de chaque match que vous jouez.",
  "google": "Continuer avec Google",
  "createAccount": "Créer un compte",
  "haveAccount": "J'ai déjà un compte",
  "editAgain": "Modifier ce match",
  "whyLink": "Pourquoi ai-je besoin d'un compte ?",
  "whyBody": "Vos matchs vous appartiennent. Un compte permet à Tennis Log de :",
  "whyB1": "sauvegarder votre historique",
  "whyB2": "synchroniser vos appareils",
  "whyB3": "construire des statistiques durables",
  "whyB4": "générer des analyses IA",
  "persisting": "Enregistrement de votre match…",
  "successTitle": "Parfait !",
  "successBody": "Votre premier match fait désormais partie de votre historique tennis.",
  "successContinue": "Ajouter plus de détails au match — facultatif"
};

data.appWelcome = {
  "heading": "Bienvenue sur Tennis Log",
  "subheading": "Ton histoire sur le court commence avec ton prochain match.",
  "googleCta": "Continuer avec Google",
  "googleHelper": "Rapide, sécurisé et sans mot de passe à retenir.",
  "guestCta": "Commencer sans compte",
  "guestHelper": "Enregistre ton premier match maintenant. Tu pourras sécuriser tes données avec Google plus tard.",
  "haveAccount": "Tu as déjà un compte ? Se connecter",
  "carouselTitle": "Que peuvent révéler 25 matchs ?",
  "carouselSubtitle": "Plus tu enregistres de matchs, plus ton jeu devient clair.",
  "carouselTitle2": "Ton Tennis Log grandit à chaque match",
  "carouselSubtitle2": "Balaie pour découvrir ce que tes statistiques peuvent devenir.",
  "card4": "Chaque séance, calories et fréquence cardiaque",
  "card5": "Tes matchs sur un calendrier",
  "card1": "Ta saison en un coup d'œil",
  "card2": "Vois comment ton jeu évolue",
  "card3": "Découvre des schémas invisibles à l'œil nu",
  "footer": "Fonctions essentielles gratuites • Tes données restent les tiennes • Conçu pour les joueurs de club",
  "prev": "Précédent",
  "next": "Suivant",
  "mini": {
    "winRate": "Taux de victoire",
    "matches": "Matchs",
    "sets": "Sets gagnés",
    "trend": "Évolution des victoires",
    "you": "Toi",
    "opponent": "Adversaire",
    "serve": "Service",
    "forehand": "Coup droit",
    "backhand": "Revers",
    "movement": "Déplacement",
    "strength": "Point fort",
    "strengthBody": "Tu gagnes 78% des matchs quand tu réalises le premier break.",
    "opportunity": "Marge de progression",
    "opportunityBody": "Ton revers baisse dans les troisièmes sets — un schéma physique ou de concentration."
  }
};

data.consent = { health: { title: "Données de santé — consentement explicite", body: "La fréquence cardiaque, les zones cardiaques, les calories, la durée de l’effort et les captures de montre connectée sont des données de santé. Tennis Log ne les traite que si vous l’autorisez explicitement, y compris leur envoi à un fournisseur d’IA pour générer vos analyses. C’est facultatif et vous pouvez le retirer à tout moment dans les Réglages, ce qui supprime les données de santé déjà enregistrées.", checkbox: "Je consens explicitement au traitement de mes données de santé par Tennis Log, comme décrit ci-dessus.", enable: "Activer les données de santé", optional: "Facultatif — Tennis Log fonctionne entièrement sans.", granted: "Données de santé activées.", stale: "Le texte de consentement a été mis à jour. Rechargez la page et relisez-le.", error: "Impossible d’enregistrer votre choix. Réessayez.", } };

data.share = {
  button: "Partager le résultat",
  dialogTitle: "Partager le résultat",
  dialogSubtitle: "Crée une image de ce match pour les réseaux sociaux. Rien n'est téléversé — l'image est générée sur ton appareil.",
  showNames: "Afficher les noms des autres joueurs",
  showLocation: "Afficher le lieu",
  saveImage: "Enregistrer l'image",
  shareImage: "Partager",
  working: "Création…",
  saved: "Image enregistrée.",
  shared: "Partagé.",
  failed: "Impossible de créer l'image. Réessaie.",
  shareUnsupported: "Cet appareil ne peut pas partager d'images — utilise Enregistrer l'image.",
  you: "Toi",
  yourTeam: "Ton équipe",
  opponent: "Adversaire",
  opposingTeam: "Équipe adverse",
  victory: "Victoire",
  defeat: "Défaite",
  draw: "Match nul",
  retired: "Abandon",
  incomplete: "Incomplet",
  retiredTag: "AB.",
};

export default data;
